/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import styles from '../authentication/components/login.module.scss';

const Language = (props) => {
  const {
    handelLanguage,
    selectedLanguage,
    handelNext,
    languages
  } = props;

  useEffect(() => {
    if (languages?.length === 1) {
      handelLanguage(languages?.[0]?.toLowerCase());
      handelNext();
    }
  }, [languages, handelNext, handelLanguage]);

  return (<>
    {languages?.length > 1
      ? <div className={styles.login_form_wrapper} style={{ borderRadius: '10px', width: 'auto', position: 'absolute', top: '40%', background: 'whitesmoke', padding: '65px' }}>
          <h4 style={{ marginBottom: '5%', fontWeight: 'bold' }}>Please Choose Your Language</h4>
          <div style={{ display: 'flex', gap: '5%', marginBottom: '5%', width: '100%', justifyContent: 'center', flexWrap: 'wrap', textTransform: 'uppercase', fontWeight: 'bold' }}>
            {languages?.map(ele => (
              <div style={{ display: 'flex' }}>
                <input type="checkbox" checked={selectedLanguage === ele.toLowerCase()} onClick={() => { handelLanguage(ele.toLowerCase()); }} style={{ width: '22px', height: '22px', marginRight: '2%' }} />
                <h5>{`${ele.slice(0, 1).toUpperCase()}${ele.slice(1)}`}</h5>
              </div>
            ))}
          </div>
          <button className={styles.nextbtn} onClick={() => { selectedLanguage && handelNext(); }}>Next</button>
        </div>
      : ''
    }
          </>
  );
};
export default Language;
